import { memo } from 'react';

import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import AccessControlSettings from './access-control/access-control-settings';
import AutomaticSSOLoginToggle from './automatic-sso-login-toggle';
import SsoAudienceListGate from './sso-audience-list-gate';
import SSORegistrationSettingsFields from './sso-registration-settings-fields';
import Text from '@ui/text/text/text';
import { ICONS } from '@ui/icons/types';
import IconWithBackdrop from '@ui/icons/icon-with-backdrop';

const SSORegistrationSettings = memo(() => {
  return (
    <div>
      <div className="margin-b-24">
        <SsoAudienceListGate />
      </div>

      <div className="flex ai-center gap-8">
        <Text tag="h5" className="H5" design="GlobalIcoText1">
          Sign in options
        </Text>
        <TooltipPortal tooltipContent={<Text design="GlobalIcoText1">Single Sign-On</Text>}>
          <IconWithBackdrop
            name={ICONS.INFO_CIRCLE}
            size={12}
            color="var(--primitives-mode-1-gray-500)"
            backdropColor="var(--primitives-mode-1-gray-100)"
          />
        </TooltipPortal>
      </div>

      <div className="flex-column gap-24">
        <SSORegistrationSettingsFields />

        <div className="flex-column gap-8">
          <div className="flex ai-center gap-8">
            <Text tag="h5" className="H5" design="GlobalIcoText1">
              Access Control
            </Text>
            <TooltipPortal tooltipContent={<Text design="GlobalIcoText1">Access Control</Text>}>
              <IconWithBackdrop
                name={ICONS.INFO_CIRCLE}
                size={12}
                color="var(--primitives-mode-1-gray-500)"
                backdropColor="var(--primitives-mode-1-gray-100)"
              />
            </TooltipPortal>
          </div>

          <AutomaticSSOLoginToggle />

          <AccessControlSettings />
        </div>
      </div>
    </div>
  );
});

SSORegistrationSettings.displayName = 'SSORegistrationSettings';

export default SSORegistrationSettings;
